/* Zumpo/Word board. */
.board,
.row {
  display: flex;
  gap: var(--zumpo-space-8);
}

.board {
  flex: none;
  flex-direction: column;
}

.small,
.small .row,
.mini,
.mini .row {
  gap: var(--zumpo-space-4);
}

/* The board a real keyboard types into shows when it has the focus. */
.board:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}
